import React, { Component } from 'react';
import { Modal, Button, Switch, Form, Input, message } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import './style/setting.less';

const FormItem = Form.Item;

class Setting extends Component {
    state = {
        pagination: {
            pageSize: 15,
            current: 1,
        },
        loading: false,
        dataList: {},
        userinfo: true,
        noticeSetting: false,
        userDetail: {},
        mailFlag: 0,
    };

    loadUserData = () => {
        const options = {
            method: 'POST',
            url: API_URL.team.queryuser,
            data: {
                userId: sessionStorage.userId,
            },
            dataType: 'json',
            doneResult: data => {
                if (!data.error) {
                    this.setState({
                        dataList: data.user,
                        userDetail: data.user.userDetail
                    });
                } else {
                    Modal.error({ title: data.error });
                }
            }
        }
        $.sendRequest(options)
    }

    loadNotice = () => {
        const options = {
            method: 'POST',
            url: API_URL.team.queryuser,
            data: {
                userId: sessionStorage.userId,
            },
            dataType: 'json',
            doneResult: data => {
                if (!data.error) {
                    this.setState({
                        dataList: data.user,
                    });
                } else {
                    Modal.error({ title: data.error });
                }
            }
        }
        $.sendRequest(options)
    }

    reload = (params = {}) => {
        const { pagination } = this.state;
        this.loadData({
            offset: pagination.current,
            ...params,
        });
    }

    reset = () => {
        const pagination = { ...this.state.pagination, current: 1 };
        this.setState({
            pagination,
        });
        this.loadData();
    }

    del = investigationId => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.del,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: () => {
                message.success('删除成功');
                this.reload();
            }
        }
        $.sendRequest(options);
    }

    btnChangeUserinfo = () => {
        this.setState({
            userinfo: true,
            noticeSetting: false,
        });
        this.loadEmailSet();
    }

    btnChangeNoticeSetting = () => {
        this.setState({
            userinfo: false,
            noticeSetting: true,
        });
    }

    loadEmailSet = () => {
        const options = {
            method: 'POST',
            url: API_URL.config.queryUserEmail,
            data: {},
            dataType: 'json',
            doneResult: (data) => {
                this.setState({ mailFlag: data.data.mailFlag });
            }
        }
        $.sendRequest(options)
    }

    toggle = (checked) => {
        const options = {
            method: 'POST',
            url: API_URL.config.userIsSendEmail,
            data: {
                mailFlag: checked ? 1 : 0,
            },
            dataType: 'json',
            doneResult: (data) => {
                message.success(data.success);
            }
        }
        $.sendRequest(options);
    }

    componentDidMount() {
        this.loadUserData();
        this.loadEmailSet();
    }

    render() {
        const { curRole } = sessionStorage;
        const { dataList, userinfo, noticeSetting, userDetail } = this.state;
        const employeeCode = userDetail.employeeCode;
        const CreateForms = Form.create()(CreateForm);
        return (
            <div className="full">
            {
                curRole != 'CTA'
                ?
                    <div className="content-2">
                        <div style={{ color: '#3D33A9' }}><i className='icon iconfont'>&#xe65b;</i>个人设置</div>
                        <div className='box home'>
                            <div className='change-btn'>
                                <a href='javascript:void(0);' onClick={this.btnChangeUserinfo} className={userinfo ? 'cur' : ''} >我的信息</a>
                                <a href='javascript:void(0);' onClick={this.btnChangeNoticeSetting} className={noticeSetting ? 'cur' : ''} >通知设置</a>
                            </div>
                            {userinfo ?
                                <ul className="preview-list" style={{ borderTop: '1px solid #ccc' }}>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">工号</label>
                                            <span className="">{employeeCode}</span>
                                        </div>
                                        <div className="item">
                                            <label className="ui-label">姓名</label>
                                            <span className="">{dataList.userCompellation}</span>
                                        </div>
                                    </li>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">职位</label>
                                            <span className="">{dataList.positionName}</span>
                                        </div>
                                        <div className="item">
                                            <label className="ui-label">部门</label>
                                            <span className="">{dataList.enterpriseDepartmentName}</span>
                                        </div>
                                    </li>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">主管</label>
                                            <span className="">{dataList.leaderName}</span>
                                        </div>
                                        <div className="item">
                                            <label className="ui-label">工作地点</label>
                                            <span className="">{dataList.cityName}</span>
                                        </div>
                                    </li>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">手机号码</label>
                                            <span className="">{dataList.userMobile}</span>
                                        </div>
                                        <div className="item">
                                            <label className="ui-label">邮箱</label>
                                            <span className="">{dataList.userEmail}</span>
                                        </div>
                                    </li>
                                </ul>
                                :
                                <ul className="preview-list" style={{ borderTop: '1px solid #ccc' }}>
                                    <li className="title preview-item" style={{ height: 42 }}></li>
                                    <li className="preview-item">
                                        <div className="item-max" style={{ textAlign: 'center' }}>
                                            <label className="ui-label" style={{ marginRight: 20 }}>是否启用邮件通知方式：</label>
                                            <span className="">
                                                <Switch checkedChildren="开" unCheckedChildren="关" onChange={this.toggle} defaultChecked={this.state.mailFlag == 1} />
                                            </span>
                                        </div>
                                    </li>
                                    <li className="title preview-item" style={{ height: 42 }}></li>
                                    <li className="title preview-item" style={{ height: 42 }}></li>
                                </ul>
                            }
                        </div>
                    </div>
                :
                <div className="content-2">
                    <div style={{ color: '#3D33A9' }}><i className='icon iconfont'>&#xe65b;</i>个人设置</div>
                    <div className='box home' style={{ width: '60%', padding: '40px' }}>
                        <CreateForms />
                    </div>
                </div>
            }
            </div>
        );
    }
}

class CreateForm extends Component {
    submit = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { newPassword, confirmPassword } = values;
                if (newPassword != confirmPassword) {
                    message.warning('两次输入的新密码不一致');
                    return;
                }
                const options = {
                    method: 'POST',
                    url: API_URL.user.modifyPassword,
                    data: { ...values },
                    dataType: 'json',
                    doneResult: (res) => {
                        message.success(res.success);
                    }
                }
                $.sendRequest(options);
            }
        });
    }

    render() {
        const { form: { getFieldDecorator } } = this.props;
        const formItemLayout = {
            labelCol: {
                sm: { span: 8 },
                md: { span: 8 },
            },
            wrapperCol: {
                sm: { span: 13, offset: 1 },
                md: { span: 13, offset: 1 },
            },
        };
        return (
            <Form>
                <FormItem {...formItemLayout} label="旧密码">
                    {
                        getFieldDecorator('password', {
                            rules: [
                                {
                                    required: true,
                                    whitespace: true,
                                    message: '请输入旧密码',
                                }
                            ]
                        })(
                            <Input type="password" placeholder="请输入" style={{ width: '240px' }} />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="新密码">
                    {
                        getFieldDecorator('newPassword', {
                            rules: [
                                {
                                    required: true,
                                    whitespace: true,
                                    message: '请输入新密码'
                                }
                            ]
                        })(
                            <Input type="password" placeholder="请输入" style={{ width: '240px' }} />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="确认新密码">
                    {
                        getFieldDecorator('confirmPassword', {
                            rules: [
                                {
                                    required: true,
                                    whitespace: true,
                                    message: '请再次输入新密码'
                                }
                            ]
                        })(
                            <Input type="password" placeholder="请输入" style={{ width: '240px' }} />
                        )
                    }
                </FormItem>
                <div style={{ marginTop: 10, textAlign: 'center' }}>
                    <Button type="primary" onClick={this.submit}>保存</Button>
                </div>
            </Form>
        );
    }
}

export default Setting;




// WEBPACK FOOTER //
// ./src/components/layout/Setting.js